package one.devsbox.shared.a

import kotlinx.serialization.Serializable


@Serializable
sealed interface App {
    val appId: Long
    val type: Int

    companion object {
        const val NO_IMAGE = -9999L
        const val NO_ICON = -9999L
    }

    @Serializable
    data class Wheel(
        override val appId: Long,
        override val type: Int = 40, // AppType.WHEEL.type
        var content: Content = Content()
    ) : App {

        companion object {}

        @Serializable
        data class Content(
            var items: MutableList<Item> = mutableListOf(
                Item(1, 1, "Item 1"),
                Item(2, 2, "Item 2"),
                Item(3, 3, "Item 3")
            ),
            var theme: Theme = Theme(),
            var wheel: ConfigWheel = ConfigWheel(),
            var timer: GameTimer = GameTimer()
        ) {}

        @Serializable
        data class Item(
            var idGroup: Long = -1,
            var idItem: Long = -1,
            var name: String = "",
            var count: Int = 100,
            var icon: Icon = Icon(),
            var color: Color = Color(),
            var reward: Reward = Reward(),
            var position: Int = 0,
            var fontSize: Int = 60,
            var nameY: Int = 30,
            var used: Int = 0,
            var countOrigin: Int = count,
        ) {}

        @Serializable
        data class ConfigWheel(
            var scale: Int = 90,
            var x: Int = 50,
            var y: Int = 50,
            var scaleCenter: Int = 20,
            var color: Color = Color(
                surface = 0xFFffFFff,
                onSurface = 0xFFffFFff
            ),
        ) {}

        @Serializable
        data class Theme(
            var backgroundApp: Long = NO_IMAGE,
            var backgroundStartup: Long = NO_IMAGE,
            var items: Color = Color(),
            var orientation: Int = ORIENTATION_PORT,
            var itemsFontSize: Int = 80,
            var iconsScale: Int = 50,
            var iconsY: Int = 60,
            var itemNameY: Int = 30,
            var backgroundColor: Long = 0xFF47A8BD,
            var triangleColor: Long = 0xFFFF0000,
        ) {
            companion object {
                const val ORIENTATION_LAND = 0
                const val ORIENTATION_PORT = 1
            }

            val isLand: Boolean get() = orientation == ORIENTATION_LAND
        }

        @Serializable
        data class Reward(
            var visual: Long = NO_IMAGE
        ) {}

        @Serializable
        data class Icon(
            var webp: Long = NO_IMAGE,
            var svg: Long = NO_ICON,
            var scale: Int = 45,
            var y: Int = 60,
        ) {
            val isSet: Boolean get() = svg != NO_ICON || webp != NO_IMAGE

            companion object {}
        }
    }

    @Serializable
    data class Color(
        var surface: Long = 0xFF3f51b5,
        var onSurface: Long = 0xFFffFFff,
    ) {}

    @Serializable
    data class GameTimer(
        var splash: Long = 10000L,
        var game: Long = 10000L,
        var result: Long = 10000L,
    ) {}
}
